import React, { useEffect, useRef, useState } from "react";
import * as styles from "./SummaryTile.module.css";
import { Cta } from "../Cta/Cta";
import { CustomRichTextElement } from "../CustomRichTextElement/CustomRichTextElement";
import { Image, KontentRichText } from "../../../types";
import { brandColors } from "../../../lib/color";
import { Link } from "../Link/Link";

export interface SummaryTileProps {
  contentCategory?: string;
  subhead: string;
  text?: KontentRichText;
  image?: Image;
  smallImage?: Image;
  ctaLabel?: string;
  ctaHref?: string;
  ctaTarget?: string;
  ctaAction?: "_blank" | "_self";
  hideTextOnMobile?: boolean;
  tileWidth?: "full" | "oneThird" | "twoThirds";
  clickableTile?: boolean;
  className?: string;
  bgPosition?: "top" | "right";
  displayImages?: boolean;
}

export const SummaryTile: React.FC<SummaryTileProps> = ({
  contentCategory,
  subhead,
  text,
  ctaLabel,
  ctaHref,
  ctaTarget,
  image,
  smallImage,
  hideTextOnMobile,
  tileWidth,
  clickableTile,
  className,
  bgPosition,
  displayImages,
}) => {
  const [bgStyle, setBgStyle] = useState<Partial<CSSStyleDeclaration>>({
    background: brandColors.navy,
  });
  const tileWrapper = useRef(null);
  let bgClass = styles.tileBg;

  if (bgPosition) {
    bgClass += ` ${styles[bgPosition]}`;
  }

  let contentTileClassName =
    tileWidth === "oneThird" || tileWidth == "twoThirds"
      ? styles.summaryTile + " " + styles[tileWidth]
      : styles.summaryTile;

  if (className) {
    contentTileClassName += ` ${className}`;
  }

  const contentContainerClassName =
    tileWidth === "oneThird" || tileWidth == "twoThirds"
      ? styles.contentContainer + " " + styles[tileWidth]
      : styles.contentContainer;

  useEffect(() => {
    const width = tileWrapper?.current?.offsetWidth
      ? tileWrapper?.current?.offsetWidth
      : 1200;

    const height = tileWrapper?.current?.offsetHeight
      ? tileWrapper?.current?.offsetHeight
      : "";

    if (displayImages) {
      setBgStyle({
        backgroundImage:
          height < 450 && smallImage?.item
            ? `url("${smallImage?.item?.url}?w=${width}")`
            : `url("${image?.item?.url}?w=${width}")`,
      });
    }
  }, []);

  const renderTile = () => {
    return (
      <div className={contentTileClassName} ref={tileWrapper}>
        <div className={bgClass} style={bgStyle}>
          <div className={styles.overlay}></div>
        </div>
        <div className={styles.container}>
          <div className={contentContainerClassName}>
            <div className={styles.content}>
              {contentCategory && (
                <div className={styles.contentCategory}>{contentCategory}</div>
              )}
              <div>
                <h2>{subhead}</h2>
                {text && (
                  <div
                    className={
                      styles.text + (hideTextOnMobile ? " hide-mobile" : "")
                    }
                  >
                    <CustomRichTextElement content={text} />
                  </div>
                )}

                {ctaLabel && ctaHref && !clickableTile && (
                  <div className={styles.ctaContainer}>
                    <Cta
                      href={ctaHref}
                      target={ctaTarget}
                      label={ctaLabel}
                      invert
                    />
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };

  return ctaHref && clickableTile ? (
    <div className={styles.clickableTile}>
      <Link to={ctaHref} target={"_self"}>
        {renderTile()}
      </Link>
    </div>
  ) : (
    renderTile()
  );
};
